import React from 'react';
import { Snackbar } from '@mui/material';
import { ErrorSnackbarProps } from '../../../types/errorSnackbar';
import { StyledAlert } from './ErrorSnackbar.styles';
const ErrorSnackbar: React.FC<ErrorSnackbarProps> = ({ error, onClose }) => {
  return (
    <Snackbar
      open={!!error}
      autoHideDuration={6000}
      onClose={onClose}
    >
      <StyledAlert
        onClose={onClose}
        severity="error"
      >
        {error}
      </StyledAlert>
    </Snackbar>
  );
};
export default ErrorSnackbar;
